import React, { useState } from 'react';
import { fmt } from '../utils/api';

const DEFAULT_SHOWN = 4;

export default function SubscriptionsSnapshot({ data, onViewAll }) {
  const [collapsed, setCollapsed] = useState(false);
  const [expanded, setExpanded] = useState(false);
  if (!data) return null;
  const { subscriptions, monthlyTotal } = data;
  const shown = expanded ? subscriptions : subscriptions.slice(0, DEFAULT_SHOWN);

  return (
    <div style={styles.panel}>
      <button style={styles.header} onClick={() => setCollapsed((c) => !c)}>
        <h2 style={styles.title}>
          <span style={styles.chevron}>{collapsed ? '▸' : '▾'}</span>
          🔄 Subscriptions
        </h2>
        <span style={styles.total}>{fmt.currency(monthlyTotal)}/mo</span>
      </button>

      {!collapsed && (
        subscriptions.length === 0 ? (
          <p style={styles.empty}>No recurring charges detected yet.</p>
        ) : (
          <div style={styles.list}>
            {shown.map((s) => (
              <div key={s.id} style={styles.row}>
                <span style={styles.name}>
                  {s.nickname || s.merchant_name}
                  {s.potentially_canceled && <span style={styles.warnDot}>⚠</span>}
                </span>
                <span style={styles.amt}>{fmt.currency(s.last_amount)}</span>
              </div>
            ))}
            <div style={styles.footer}>
              {subscriptions.length > DEFAULT_SHOWN && (
                <button style={styles.more} onClick={() => setExpanded((e) => !e)}>
                  {expanded ? 'Show less' : `Show all ${subscriptions.length}`}
                </button>
              )}
              {onViewAll && (
                <button style={styles.viewAllBtn} onClick={onViewAll}>
                  Manage subscriptions →
                </button>
              )}
            </div>
          </div>
        )
      )}
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.25rem',
  },
  header: {
    background: 'transparent',
    border: 'none',
    width: '100%',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.75rem',
  },
  chevron: {
    display: 'inline-block',
    color: '#6b7280',
    marginRight: '4px',
  },
  title: {
    margin: 0,
    fontSize: '0.9rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  total: {
    color: '#fbbf24',
    fontSize: '0.8rem',
    fontWeight: '700',
    fontFamily: "'DM Mono', monospace",
  },
  list: {},
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.4rem 0',
    borderBottom: '1px solid #1e2a3a',
  },
  name: {
    color: '#9ca3af',
    fontSize: '0.8rem',
    fontFamily: "'Syne', sans-serif",
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
  },
  warnDot: { fontSize: '0.7rem' },
  amt: {
    color: '#e5e7eb',
    fontSize: '0.8rem',
    fontFamily: "'DM Mono', monospace",
  },
  more: {
    background: 'transparent',
    border: 'none',
    color: '#6b7280',
    fontSize: '0.7rem',
    fontWeight: '600',
    cursor: 'pointer',
    padding: 0,
    fontFamily: "'Syne', sans-serif",
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '0.6rem',
  },
  viewAllBtn: {
    background: 'transparent',
    border: 'none',
    color: '#00d4aa',
    fontSize: '0.72rem',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    padding: 0,
    marginLeft: 'auto',
  },
  empty: {
    color: '#4b5563',
    fontSize: '0.8rem',
    margin: 0,
  },
};
